import React, { useState, useEffect, useCallback } from 'react';
import { Content, Row, Col, Title, Tabs, Text } from 'components';
import { Avatar } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUserStack } from 'store';

// Route
import SalesStatus from './SalesStatus';
import StoreStatus from './StoreStatus';
import MenuManagement from './MenuManagement';
import StaffManagement from './StaffManagement';
// import { OrderStatus } from '../components';

const StoreManagement = (props) => {
  const userInfo = useUserStack();
  /* ===== Route ===== */

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const routeKey = searchParams.get('key');

  /* ===== Props ===== */
  const { setSelectedKeys } = props;

  /* ===== State ===== */
  const [tabKey, setTabKey] = useState('sales-status');

  /* ===== Variable ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
  };

  /* ===== Function ===== */
  /**
   * 탭별 렌더링
   * --
   */
  const renderTabView = useCallback(() => {
    switch (tabKey) {
      case 'sales-status':
        return <SalesStatus />;
      case 'store-status':
        return <StoreStatus />;
      case 'menu-management':
        return <MenuManagement />;
      case 'staff-management':
        return <StaffManagement />;
      default:
        return null;
    }
  }, [tabKey]);

  /**
   * 탭키 핸들러
   * --
   */
  const handleTabKey = (key) => {
    navigate(`/store?key=${key}`);
    setSelectedKeys(key);
  };

  /* ===== Hooks ===== */
  /**
   * 쿼리스트링 값 추출
   * --
   */
  useEffect(() => {
    setTabKey(routeKey);
  }, [routeKey]);

  /* ===== Render ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>매장 관리</Title>

            <Row gutter={[1, 1]}>
              {/* 탭 */}
              <Col x={24}>
                <Content
                  maxWidth={'100%'}
                  padding={0}
                  style={{ height: '100%' }}
                >
                  <div style={{ position: 'relative', top: 0, left: 0 }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'absolute',
                        top: '50%',
                        left: 20,
                        transform: 'translate(0, -50%)',
                      }}
                    >
                      <Avatar size={32} shape="square" />
                      <Text
                        size={18}
                        weight={700}
                        color={'#242424'}
                        style={{ marginLeft: 10 }}
                      >
                        {userInfo?.shop_information_name}
                      </Text>
                    </div>
                    <div style={{ paddingTop: 8 }}>
                      <Tabs
                        items={[
                          { label: '판매현황', key: 'sales-status' },
                          { label: '지점현황', key: 'store-status' },
                          { label: '메뉴관리', key: 'menu-management' },
                          { label: '직원관리', key: 'staff-management' },
                        ]}
                        position="center"
                        activeKey={tabKey}
                        onChange={(e) => handleTabKey(e)}
                      />
                    </div>
                  </div>
                </Content>
              </Col>
              {/* 탭 */}

              {/* 내용 */}
              <Col x={24}>
                <Content
                  maxWidth={'100%'}
                  padding={0}
                  style={{ height: '100%' }}
                >
                  {renderTabView()}
                </Content>
              </Col>
              {/* 내용 */}
            </Row>
          </Col>
        </Row>
      </Content>

      {/* <OrderStatus right={40} /> */}
    </>
  );
};

export default StoreManagement;
